export const isValidInn = (inn: string): boolean => {
  const digits = inn.replace(/\D/g, '')
  return digits.length === 10 || digits.length === 12
}
